<script>
import utils from '@/utils/common';

import FormBlock from '@/components/FormBlock.vue';
import UserDetailTileField from '@/components/user/UserDetailTileField.vue';

export default {
  name: 'UserDetailSettingsTile',
  components: { FormBlock, UserDetailTileField },
  props: {
    isEditMode: Boolean,
    value: Object,
  },
  computed: {
    dateBirth() {
      return this.value.dateBirth ? utils.convertDateToString(new Date(this.value.dateBirth), 'numeric') : '';
    },

    gender() {
      if ((this.value.gender === null) || this.value.gender === undefined) return 'не указан';
      return this.value.gender ? 'мужской' : 'женский';
    },

    countryOptions() {
      return ['Россия'];
    },

    cityOptions() {
      return ['Москва', 'Санкт-Петербург'];
    },

    timeZoneOptions() {
      return [0, 1, 2, 3];
    },

    genderOptions() {
      return [
        { value: true, label: 'мужской' },
        { value: false, label: 'женский' },
      ];
    },

    settingsFields() {
      return [
        {   name: 'country',    title: 'Страна',          value: this.value.country,      displayValue: this.value.country,     emptyValue: 'не указана',   displayView: 'horizontal',    editView: 'horizontal',     changeType: 'input',       options: this.countryOptions, hideNotSelected: false      }, // eslint-disable-line
        {   name: 'city',       title: 'Город',           value: this.value.city,         displayValue: this.value.city,        emptyValue: 'не указан',    displayView: 'horizontal',    editView: 'horizontal',     changeType: 'input',       options: this.cityOptions, hideNotSelected: false,    borderBottom: true                }, // eslint-disable-line
        // {   name: 'timezone',   title: 'Часовой пояс',    value: this.value.timezone,     displayValue: this.value.timezone,    emptyValue: 'не указан',    displayView: 'vertical',      editView: null,     changeType: 'select',       options: this.timeZoneOptions, hideNotSelected: false,    borderBottom: true                }, // eslint-disable-line
        {   name: 'dateBirth',  title: 'Дата рождения',   value: this.value.dateBirth,    displayValue: this.dateBirth,         emptyValue: 'не указана',   displayView: 'horizontal',    editView: 'horizontal',   changeType: 'date',   datePickerValue: this.value.dateBirth,                                  }, // eslint-disable-line
        // {   name: 'workInfo',   title: 'Опыт работы',     value: this.value.workInfo,     displayValue: this.value.workInfo,    emptyValue: 'не указан',    displayView: 'horizontal',    editView: 'horizontal',   changeType: 'input',        borderBottom: this.isEditMode     }, // eslint-disable-line
        {   name: 'gender',     title: 'Пол',             value: this.value.gender,       displayValue: this.gender,            emptyValue: 'не указан',    displayView: 'horizontal',    editView: 'vertical',     changeType: 'select',       options: this.genderOptions, hideNotSelected: false                                  }, // eslint-disable-line
      ];
    },
  },
  methods: {
    onChange(name, value) {
      console.log({ [name]: value });
      this.$emit('change', { [name]: value });
    },
  },
};
</script>

<template lang="pug">
  FormBlock(mobile)
    .b-user-detail-settings-tile(v-if="value")
      ._header Настройки
      ._settings-block
        UserDetailTileField(v-for="field in settingsFields" :key="field.name" :field="field" :isEditMode="isEditMode" @change="onChange(field.name, $event)")
</template>

<style scoped lang="scss">
.user-detail-settings-tile {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  &__header {
    display: flex;
    padding-bottom: 15px;
    border-bottom: rgba(235, 239, 242, 1) 1px solid;
    font-family: Geometria, sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(30, 49, 71, 1);
  }

  &__settings-block {
    padding-bottom: 50px;
    padding-top: 25px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
}
</style>
